/* src/app/feedback/feedback.component.scss */
.page {
  position: relative;
  display: flex;
  width: 1180px;
  height: 620px;
  border-radius: 20px;
  background-color: #3D3F47;
  margin: 0 auto;
  padding: 30px;
  justify-content: center;
  flex-direction: column;
}
.page .required {
  margin-left: 10px;
  text-align: left;
  font-size: 1.5rem;
  color: #ff495c;
  margin-top: 10px;
}
.page.has-reflection-image .elements {
  flex-direction: row;
}
.page.has-reflection-image .elements .text {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  min-width: 720px;
}
.page.has-reflection-image .elements .text p {
  margin-bottom: 20px;
}
.page.has-reflection-image .elements .text h1 {
  font-family: "Campton-Bold";
}
.page.has-reflection-image .elements .image {
  min-width: 380px;
}
.page.align-top {
  justify-content: flex-start;
  padding-top: 70px;
}
.page .ng-star-inserted {
  width: 100%;
}
.page .page-counter {
  position: absolute;
  top: 30px;
  left: 30px;
  display: inline-block;
  margin-bottom: 30px;
  text-align: left;
  font-style: italic;
}
.page .elements {
  display: flex;
  flex-direction: column;
  justify-content: left;
  align-items: flex-start;
}
.page .text {
  font-family: "Campton-Light";
  text-align: left;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}
.page .text h1 {
  font-family: "Campton-Light";
  font-size: 34px;
  font-style: normal;
  font-weight: 400;
  line-height: 46px;
  margin-bottom: 50px;
}
.page .text h1.bold {
  font-family: "Campton-bold";
}
.page .image {
  border-radius: 20px;
  width: 380px;
  height: 520px;
}
.page .question-area {
  width: 100%;
}
.page .question-area input {
  width: 100%;
  line-height: 40px;
  font-size: 20px;
  padding: 3px 20px;
  border-radius: 10px;
  border: 1px solid #d9d9d9;
  font-weight: bold;
}
.page .question-area textarea {
  margin-top: 20px;
  width: 100%;
  height: 340px;
  border-radius: 20px;
  border: 1px solid #d9d9d9;
  resize: none;
  padding: 20px;
  font-size: 20px;
}
.buttons {
  width: 1180px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
}
.buttons.only-next {
  justify-content: right;
}
.buttons.only-start {
  justify-content: right;
}
.buttons.only-back {
  justify-content: flex-start;
}
::placeholder {
  color: #888;
  opacity: 1;
  font-family: inherit;
  font-size: inherit;
  font-weight: normal;
}
/*# sourceMappingURL=feedback.component.css.map */
